// extracted by mini-css-extract-plugin
export default {"navdib":"FiltersNav_navdib__YSPE3","selects":"FiltersNav_selects__wBwji","label":"FiltersNav_label__jUnc0"};